export default {
  groupProject: '项目管理',
  groupAdmin: '管理员',
  groupSuperAdmin: '超级管理员',
  photoLive: '照片直播',
  conference: '会务系统',
  eventManage: '活动管理',
  registrationManage: '报名管理',
  hotelManage: '酒店管理',
  accountManage: '账号管理',
  roleManage: '角色管理',
  permissionManage: '权限管理',
  companyManage: '公司管理'
}
